{
  "events": [
    {
      "title": "Slava Ukraine: Metal Fundraiser",
      "date": "Saturday, 21 February 2026",
      "time": "Doors 6:00 pm · 10:00 pm",
      "bands": "Centrilia, Jorogumo, Permacrisis, Burning the Dream",
      "venue": "Classic Grand Ballroom, 18 Jamaica Street, Glasgow, G1 4QD",
      "tickets": "£15.00 (+ £1.50 booking fee) or £20.00 donation ticket (+ £2.00 booking fee)",
      "agePolicy": "Over 14s · Early birds available until 31 December 2025",
      "ticketLink": "https://tickets-scotland.com//events.html?event_method=viewevent&event_id=809a7cbd-d754-11f0-b1db-060035c00d11",
      "locationTag": "Glasgow"
    },
    {
      "title": "Slava Ukraini: Metal Fundraiser",
      "date": "Saturday, 21 November 2026",
      "time": "Doors 7:00 pm · 10:30 pm",
      "bands": "Cnoc An Tursa, Chekhov's Gun, Pict, Arc Arrival",
      "venue": "Ivory Blacks, Glasgow",
      "tickets": "£20.00 or £25.00 donation ticket (+ £1.50 booking fee)",
      "agePolicy": "Over 18s only",
      "ticketLink": "https://tickets-scotland.com/whats-on/slava-ukraine-uk-metal-fundraiser-for-ukraine",
      "locationTag": "Glasgow"
    }
  ]
}
